import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function AnimationOrder() {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('all')

  useEffect(() => { loadOrders() }, [])

  const loadOrders = () => {

    setLoading(true)
    fetch(`${API}/ai-camp/animations`)
      .then(r => r.json())
      .then(d => { if (d.success) setOrders(d.data || []) })
      .catch(err => console.error('获取动画订单失败', err))
      .finally(() => setLoading(false))
  }

  const getStatusBadge = (status) => {
    const map = {
      submitted: { bg: '#fffbe6', color: '#faad14', text: '待接制作' },
      processing: { bg: '#e6f4ff', color: '#1890ff', text: '制作中' },
      completed: { bg: '#f6ffed', color: '#52c41a', text: '已完成' },
      rejected: { bg: '#fff1f0', color: '#ff4d4f', text: '已拒绝' },
    }
    const s = map[status] || { bg: '#f5f5f5', color: '#999', text: status }
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: s.bg, color: s.color }}>{s.text}</span>
  }

  const getCareerIcon = (career) => {
    const icons = { '医生': '👨‍⚕️', '消防员': '👨‍🚒', '科学家': '🔬', '画家': '🎨', '飞行员': '✈️', '老师': '👨‍🏫', '厨师': '👨‍🍳', '建筑师': '🏗️', '记者': '📰', '驯兽师': '🐬' }
    return icons[career] || '🎭'
  }

  const filtered = filter === 'all' ? orders : orders.filter(o => o.status === filter)

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>加载中...</div>

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div><h2 style={{ fontSize: 20, margin: 0 }}>🎬 AI动画订单</h2><p style={{ color: '#999', fontSize: 13, margin: '4px 0 0' }}>AI创作营学员产出的动画订单</p></div>
        <div><span style={{ fontSize: 13, color: '#666' }}>待处理 <span style={{ color: '#faad14', fontWeight: 600, fontSize: 16 }}>{orders.filter(o => o.status === 'submitted').length}</span> 单</span></div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[{ k: 'all', l: '全部' }, { k: 'submitted', l: '待接制作' }, { k: 'processing', l: '制作中' }, { k: 'completed', l: '已完成' }].map(f => (
          <button key={f.k} onClick={() => setFilter(f.k)} style={{ padding: '6px 16px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 13, background: filter === f.k ? '#1890ff' : '#f5f5f5', color: filter === f.k ? '#fff' : '#666' }}>
            {f.l} ({f.k === 'all' ? orders.length : orders.filter(o => o.status === f.k).length})
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, background: '#fff', borderRadius: 8, color: '#999' }}>暂无订单</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
          {filtered.map(o => (
            <div key={o.id} style={{ background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 32 }}>{getCareerIcon(o.career)}</span>
                  <div>
                    <div style={{ fontWeight: 500 }}>{o.childName || o.child_name || '-'}</div>
                    <div style={{ fontSize: 12, color: '#666' }}>{o.career || o.career_name || '-'}职业体验</div>
                  </div>
                </div>
                {getStatusBadge(o.status)}
              </div>
              <div style={{ fontSize: 13, marginBottom: 8 }}>
                <span style={{ background: '#f5f5f5', padding: '2px 8px', borderRadius: 4, color: '#666' }}>{o.product || o.product_name || '-'}</span>
              </div>
              <div style={{ fontSize: 12, color: '#999', marginBottom: 8 }}>🏫 {o.institution || o.institution_name || '-'}</div>
              <div style={{ fontSize: 12, color: '#999', marginBottom: 12 }}>📅 {o.submittedAt || o.created_at || '-'}</div>

              {o.status === 'completed' && o.videoUrl && (
                <div style={{ height: 100, background: '#f5f5f5', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12, cursor: 'pointer' }}>
                  <span style={{ fontSize: 32 }}>▶️</span>
                </div>
              )}

              <div style={{ display: 'flex', gap: 8 }}>
                {o.status === 'submitted' && (
                  <>
                    <button onClick={() => { setOrders(prev => prev.map(x => x.id === o.id ? { ...x, status: 'processing' } : x)); alert('已接单，开始制作动画') }} style={{ flex: 1, padding: '8px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>接单制作</button>
                    <button onClick={() => alert('查看学员提交的职业画作和描述')} style={{ padding: '8px 12px', background: '#f5f5f5', color: '#666', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>详情</button>
                  </>
                )}
                {o.status === 'processing' && (
                  <>
                    <button onClick={() => { setOrders(prev => prev.map(x => x.id === o.id ? { ...x, status: 'completed' } : x)); alert('已完成！将生成领取码通知家长') }} style={{ flex: 1, padding: '8px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>完成交付</button>
                    <button style={{ padding: '8px 12px', background: '#f5f5f5', color: '#666', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>查看</button>
                  </>
                )}
                {o.status === 'completed' && (
                  <button onClick={() => alert('动画播放功能开发中')} style={{ flex: 1, padding: '8px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>查看动画</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
